import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import zhCN from 'ant-design-vue/es/locale/zh_CN';
  import dayjs from 'dayjs';
  import 'dayjs/locale/zh-cn';
  import { reactive, onMounted } from 'vue';
  import Router from './Router';
  import { AccountService } from './Services/AccountService';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  dayjs.locale('zh-cn');
  const state = reactive({
    locale: zhCN
  });

  onMounted(async () => {
    // 从 localStorage 中读取 'user-token'
    const token = localStorage.getItem('OnlineBusinessHall.Token');
    if (token) {
      // 更新令牌，延续令牌可用性
      await AccountService.heartbeatKeep().then((is_success:boolean) => {
        if (!is_success) {
          // 跳转到登录页
          Router.push({ path: '/login' });
        } else {
          Router.push({ path: '/backend' });
        }
      }).catch(() => {
        // 令牌已过期，跳转到登录页
        Router.push({ path: '/login' });
      });
    } else {
      // 跳转到登录页
      Router.push({ path: '/login' });
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, {
    locale: state.locale
  }, {
    default: _withCtx(() => [
      _createVNode(_component_RouterView)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})